import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { FAQS } from './salesData';

/** Preguntas frecuentes, en acordeón. */
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="w-full bg-white py-16 sm:py-20" data-id="element-51" data-mp="1gkeqxv914hi4">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-6" data-id="element-52" data-mp="248o8gkz7mj3g">
        <div className="text-center" data-id="element-53" data-mp="24ban14kipyv6">
          <SectionTag data-id="element-54" data-mp="28bb6j3mh5093">Preguntas frecuentes</SectionTag>
          <h2 className="mt-4 font-display text-[1.85rem] font-extrabold leading-tight text-ink sm:text-[2.3rem]" data-id="element-55" data-mp="28cvwsh1r9x15">
            Lo que suelen preguntar antes de comprar
          </h2>
        </div>

        <ul className="mt-9 divide-y divide-fog border-y border-fog" data-id="element-56" data-mp="1zgd85h0k4vad">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} data-id="element-57" data-mp="2s0br6fmbinun" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-wa" data-id="element-58" data-mp="2s0ljwayqz941">
                  <span className="font-display text-[1rem] font-bold leading-snug text-ink" data-id="element-59" data-mp="19tve02rghqtg">
                    {faq.q}
                  </span>
                  <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-wa-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden strokeWidth={2.5} data-id="element-60" data-mp="1ohgf5r4rtfyq" />
                </button>

                <AnimatePresence initial={false} data-id="element-61" data-mp="35yido56n1ju">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-62" data-mp="37ro917z1hqs">
                      <p className="pb-5 pr-8 font-sans text-[0.93rem] leading-relaxed text-slate" data-id="element-63" data-mp="286hopppkwapz">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}